// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"088ce796","364":"938dd2af","366":"ed7a4e73","503":"0004cbd2","635":"92570267","730":"ddde97e5","736":"1e30fb05","825":"bf4265f4","949":"f4db75ba","966":"d515dd6c"}[chunkId] + ".chunk.js";
};